import axios from "axios";

const FetchLogs = (company_id, params, config) => {
  return axios.get(`/api/v1/companies/${company_id}/approval_logs`, {
    params,
    ...config,
  });
};

const ApiApprovalLogs = {
  FetchLogs,
};

export default ApiApprovalLogs;
